import * as types from './actionTypes';
import { defaultStore, ISettingsStore } from './store';

export default (
  state: ISettingsStore = defaultStore,
  action: types.ISettingsActions
): ISettingsStore => {
  switch (action.type) {
    case types.SET_SETTINGS:
      return { ...state, ...action.payload };
    case types.SET_VIEWTYPE:
      localStorage.setItem('archiveViewType', action.payload);
      return { ...state, archiveViewType: action.payload };
    case types.SET_LINKS_PER_PAGE:
      localStorage.setItem('archiveLinksPerPage', String(action.payload));
      return { ...state, archiveLinksPerPage: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/settings/reducers.tsx